/* 

    Created By: Umair Khan
    Created Date: September 22, 2016

    Directive to construct Grid
    
    Arguments:

    @columnData: Date to be passed to the grid. Sample: [ { "title1" : "item1", "title2" : "item2" } , { "title1" : "item1", "title2" : "item2" } ],
    @columnNames: Column names for the grid: Sample: [ { title: "Column 1" }, { title: "Column 2" }, { title: "Column 3" }, ];
    @canRemoveRow: true if any row is removeable,
    @removeCallback: pass the funtion to be invoked when row is removed


*/

(function () {
 
    angular.module('tmx-common').directive('tmxAreachart', tmxAreachart);

    function tmxAreachart() {

        return {
            scope: {
                data: "=",
                field: "@",
                dir: "@",
                type: "@",
                series: "=",
                title: "@",
                categories: "=",
                stack: "@"
            },
            require: 'ngModel',
            restrict: 'E',
            templateUrl: 'common/directives/tmxareachart/tmxareachart.html',
            controller: tmxAreachartCtrl,
            controllerAs: 'AreaChartCtrl'

        }
    }
    function tmxAreachartCtrl($scope, $rootScope) {
        $scope.onSeriesHover = function (e) {
            kendoConsole.log(kendo.format("event :: seriesHover ({0} : {1})", e.series.name, e.value));
        };

        var tmxAreachartVM = this
        tmxAreachartVM.series = $scope.series;
        tmxAreachartVM.title = $scope.title;
        tmxAreachartVM.categories = $scope.categories;
        tmxAreachartVM.type = $scope.type;
        tmxAreachartVM.stack = $scope.stack;
        tmxAreachartVM.tooltip = "{ visible: 'true', template: '#= series.name #' }"
        tmxAreachartVM.electricity = new kendo.data.DataSource({
            transport: {
                read: {
                    url: $scope.data,
                    dataType: "json"
                }
            },
            sort: {
                field: $scope.field,
                dir: $scope.dir
            }
        });

        tmxAreachartVM.chartOptions = /* chart data*/
            {
                "title": {
                    "text": tmxAreachartVM.title,
                    "position": "bottom"
                },
                "legend": {
                    "visible": true,
                    "position": "top"
                    
                },
                "seriesDefaults": {
                    "type": 'area',
                    "stack": { // variation of normal area graph,comment it if not in use
                        "type": "100%"
                    }
                    // "line": {
                    //     "style": "step"
                    // }
                    
                   
                },
                "categoryAxis": {
                    "categories": tmxAreachartVM.categories,
                    "majorGridLines": {
                        "visible": true
                    },
                    "labels": {
                        "padding": {top: 135}
                    }
                },
               
                "series": tmxAreachartVM.series,

               
                "dataSource": tmxAreachartVM.electricity,
                "tooltip": {
                    "visible": true,
                    "template": "#= series.name #: #= value #"
                }

            }

    }

})();